import React from "react";
import { Router } from '@reach/router';
import Index from './components/Index';
import Show from './components/Show';

export default function games(props) {
  return (
        <Router>
          <Index hasImportant={props.hasImportant} path='/' />
          <Show path='/:id/*' />
        </Router>
    );
}